import './index.less'

export default class MembershipBanner {
    constructor() {
        // 登录按钮
        this.loginBtn = document.querySelector('[data-membership-login-button]')

        this.loginBtn && this.init()

        // 倒计时
        new MembershipCountdown({ loginBtn: this.loginBtn, })
    }
    init() {
        this.loginBtn.onclick = () => {
            window?.jackeryLoginApp?.modalLogin({
                return_url: window.location.href,
                register_act: 'MB-Register',
            })
        }
    }
}

// 倒计时
class MembershipCountdown {
  constructor({ loginBtn, }) {
      // 获取 DOM 元素
      this.targetDOM = document.querySelector('[data-countdown-main]')
      this.timeDOM = this.targetDOM?.querySelector('[data-countdown-time]')
      this.labelDOM = this.targetDOM?.querySelector('[data-countdown-label]')

      this.loginBtn = loginBtn

      this.targetDOM && this.initDOM()
  }
  initDOM() {
    const { countdownStartStr, countdownEndStr, countdownLabelStr, } = this.targetDOM.dataset

    // 自定义 labels 多语言
    this.labels = countdownLabelStr?.split(',') || []

    // 渲染 time 和 labels
    if (this.labels) {
        this.timeDOM.innerHTML = this.renderDOM('', '', '', '')
        this.renderLabels()
    }

    // 渲染数据
    this.initData({
        startTime: new Date(countdownStartStr).getTime(),
        endTime: new Date(countdownEndStr).getTime(),
    })
  }
  async initData({ startTime, endTime, }) {
      const { api, cr, shopId, } = window.pageInfo
      // 获取服务器时间
      const url = `${api}/osconsumerapi/v1/com/get-server-time?shopify_shop_id=${shopId || ''}&cr=${cr || ''}`
      const response = await fetch(url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          headers: {
              "Content-Type": "application/json",
          },
      });
      const { data, } = await response.json();
      const serverTime = new Date(data.datetime).getTime()

      if (serverTime >= startTime) {
          // 更新 ga 埋码文案
          if (this.loginBtn) {
            this.loginBtn.dataset.gaParamsPosition = 'countdown'
          }

          this.targetDOM.style.height = 'auto'
          this.targetDOM.classList.remove('opacity-0', 'translate-y-[20px]')
          this.tick(endTime, serverTime)
      } else {
          this.targetDOM.parentElement.removeChild(this.targetDOM)

          // 更新 ga 埋码文案
          if (this.loginBtn) {
            this.loginBtn.dataset.gaParamsPosition = 'default'
          }
      }
  }
  renderDOM(days, hours, minutes, seconds) {
      return `
          <span>${days || ''}</span>
          <span>${hours || ''}</span>
          <span>${minutes || ''}</span>
          ${this.labels.length >= 4 ? `<span>${seconds || ''}</span>` : ''}
      `
  }
  renderLabels() {
      const length = this.labels.length >= 4 ? 4 : 3
      const validLabels = [...Array.from({ length, }, (_, i) => this.labels[i] || '')]

      this.labelDOM.innerHTML = validLabels.reduce((prev, next) => prev += `<span>${next}</span>`, '')
  }
  tick(target, current) {
      const leftTime = (target - current) / 1000
      let days, hours, minutes, seconds

      if (leftTime <= 0) {
          this.timer && clearTimeout(this.timer)

          // 移除本身 DOM
          this.targetDOM.parentElement.removeChild(this.targetDOM)

          // 更新 ga 埋码文案
          if (this.loginBtn) {
            this.loginBtn.dataset.gaParamsPosition = 'default'
          }
      } else {
          days = String( parseInt(leftTime/60/60/24) ).padStart(2, '0')
          hours = String( parseInt(leftTime/60/60%24) ).padStart(2, '0')
          minutes = String( parseInt(leftTime/60%60) ).padStart(2, '0')
          seconds = String( parseInt(leftTime%60) ).padStart(2, '0')

          this.timeDOM.innerHTML = this.renderDOM(days, hours, minutes, seconds)

          this.timer = setTimeout(() => this.tick(target, current + 1000), 1000)
      }
  }
}

